var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('xt-action',{attrs:{"title":"0","icon":_vm.item.liked ? 'icon-like-full' : 'icon-like',"statistics":_vm.item.likeCount},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }